export default __webpack_public_path__ + "static/media/video2.289418ac.mp4";